import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ApiRequestsService, RESPONSE } from 'src/app/services/api-requests.service';
import { AuthService } from 'src/app/services/auth.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { ModalResultsServicesService } from 'src/app/services/modal-results-services.service';
import { UploadFileModalComponent } from 'src/app/shared/upload-file-modal/upload-file-modal.component';
import { mkConfig, generateCsv, download } from "export-to-csv";
import { ToastrService } from 'ngx-toastr';
import { DataManipulateService } from 'src/app/services/data-manipulate.service';
import { ExcelFileNameModalComponent } from 'src/app/pages/excel-file-name-modal/excel-file-name-modal.component';
import { ChangePasswordModalComponent } from 'src/app/shared/change-password-modal/change-password-modal.component';
import { UploadZipRarModalComponent } from 'src/app/shared/upload-zip-rar-modal/upload-zip-rar-modal.component';
import { SharedService } from 'src/app/services/shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss']
})
export class DefaultHeaderComponent implements OnInit {
  activeButton: string = '';
  vClass: string = 'btn btn-light active';
  hClass: string = 'btn btn-light';
  errormessage: string = "";
  errorMessage: string = "";
  fieldComparison: any = {};
  comparisonResults: any;
  username: string = '';
  showTable: boolean = false;

  showProgress = false;
  progress = 0;
  totalFiles = 0;
  processedFiles = 0;
  completedFiles = 0;
  currentFileName = '';

  constructor(public common: CommonFunctionService, private sharedSer: SharedService,
    public modalResult: ModalResultsServicesService, private router: Router,
    private authService: AuthService, private commonApi: ApiRequestsService,
    private config: NgbModalConfig, private modalService: NgbModal,
    private http: HttpClientModule, private toaster: ToastrService, private datamanipulate: DataManipulateService,
    private ngbModal: NgbModal, public modalResults: ModalResultsServicesService) { }

  ngOnInit(): void {
    this.vClass = 'btn btn-light active';
    this.hClass = 'btn btn-light';
    this.username = this.datamanipulate.userName;

    this.common.webSocket.ITRJsonEvent.subscribe((data: any) => {
      if (!this.showProgress) return;

      if (data['type'] === 'P') {
        this.currentFileName = data['fileName'];
        this.processedFiles++;
        this.progress = Math.round(
          (this.processedFiles / this.totalFiles) * 100
        );
      }

      if (data['type'] === 'C') {
        this.completedFiles++;
        if (this.completedFiles >= this.totalFiles) {
          this.showProgress = false;
        }
      }
    });
  }

  getInitials(username: string): string {
    if (!username) return '';
    const nameParts = username.split(' ');
    const firstNameInitial = nameParts[0]?.charAt(0).toUpperCase() || '';
    const lastNameInitial = nameParts[1]?.charAt(0).toUpperCase() || '';
    return `${firstNameInitial}${lastNameInitial}`;
  }

  exportToExcel = async () => {

    const username = this.username; 
    const currentDate = new Date();
    // let currentDate = new Date().toISOString().split('T');
     
    const formattedDateTime = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}_${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')}`;

    const defaultFileName = `${username}_${formattedDateTime}`;

    const ngbModelRef = this.ngbModal.open(ExcelFileNameModalComponent, {
      windowClass: 'create-misllenious-modal', backdrop: 'static', backdropClass: 'misllenious-modal-backdrop'
    });
    ngbModelRef.componentInstance.defaultFileName = defaultFileName;
    ngbModelRef.result.then(async (fileName: string) => {
      const APIName = `process/ExcelData`;
      try {
        const res = await this.commonApi.getAPICallReturningPromise(APIName, "");
        if (res['errorCode'] === this.commonApi.NO_ERROR) {
          if (res['Data'] && Array.isArray(res['Data']) && res['Data'].length > 0) {
            const csvConfig = mkConfig({ useKeysAsHeaders: true, filename: fileName });
            let resData: any[] = [];
            resData = res['Data'];
            let formattedData = resData.map(item => {
              return {
                ...item,
                acknowledgementno: `="${item.acknowledgementno}"`
              };
            });

            console.log(formattedData);
            const csv = generateCsv(csvConfig)(formattedData);

            download({ ...csvConfig, filename: fileName })(csv);
            this.toaster.success('File downloaded successfully as ' + fileName + '.csv');
            // download(csvConfig)(csv);
            // new ngxCsv(formattedData, 'My Report');
          } else {
            console.error(res['errorDescription']);
            this.toaster.error('No Data Found.');
          }
        } else {
          console.error(res['errorDescription']);
          this.toaster.error(res['errorDescription'] || 'Error fetching data.');
        }
      } catch (error) {
        console.error('Error in API call:', error);
        this.toaster.error('Error fetching data.');
      }
      if (!fileName) {
      }
    });
  }

  toggle() {
    document.body.classList.toggle('sidebar-lg-show');
  }

  logout() {
    this.modalResult.viewType = 'Vertical';
    this.authService.logout();
  }

  openFileModal(modelFor: string, apiPath: string) {
    
    let ngbModelRef = this.ngbModal.open(UploadFileModalComponent, { windowClass: 'upload-file-modal', backdrop: 'static', backdropClass: 'upload-file-backdrop' }); /****fullscreen: true, scrollable: true*/

    ngbModelRef.componentInstance.modalAction = 'attributes';
    ngbModelRef.componentInstance.modelFor = modelFor;
    ngbModelRef.componentInstance.apiName = apiPath;

    this.modalResult.disableHeaderButton = true;

    const preventBack = (event: any) => {
      event.preventDefault();
      window.history.pushState(null, "", window.location.href);
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener('popstate', preventBack);

    const warnUserOnRefresh = (event: any) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener('beforeunload', warnUserOnRefresh);

    ngbModelRef.result.then((result) => {
      if (!result) {
        this.modalResult.selectedType = "";
        this.modalResult.disableHeaderButton = false;
      }
      window.removeEventListener('popstate', preventBack);
      window.removeEventListener('beforeunload', warnUserOnRefresh);
    }, () => {
      // Handle modal dismissal and restore back button functionality
      window.removeEventListener('popstate', preventBack);
      window.removeEventListener('beforeunload', warnUserOnRefresh);
    });

  }

  uploadZipFileModal(modelFor: string, apiPath: string) {
    this.activeButton = 'uploadZip';
    if (this.disableActions) return
    let ngbModelRef = this.ngbModal.open(UploadZipRarModalComponent, { windowClass: 'upload-file-modal', backdrop: 'static', backdropClass: 'upload-file-backdrop' }); /****fullscreen: true, scrollable: true*/

    ngbModelRef.componentInstance.modalAction = 'attributes';
    ngbModelRef.componentInstance.modelFor = modelFor;
    ngbModelRef.componentInstance.apiName = apiPath;

    this.modalResult.disableHeaderButton = true;

    const preventBack = (event: any) => {
      event.preventDefault();
      window.history.pushState(null, "", window.location.href);
    };

    window.history.pushState(null, "", window.location.href);
    window.addEventListener('popstate', preventBack);

    const warnUserOnRefresh = (event: any) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener('beforeunload', warnUserOnRefresh);

    ngbModelRef.result.then((result) => {
      if (!result) {
        this.modalResult.selectedType = "";
        this.modalResult.disableHeaderButton = false;
      } else if (result?.totalFiles) {
        this.totalFiles = result.totalFiles;
        this.processedFiles = 0;
        this.completedFiles = 0;
        this.progress = 0;
        this.showProgress = true;
      }
    },
      () => {
        window.removeEventListener('popstate', preventBack);
        window.removeEventListener('beforeunload', warnUserOnRefresh);
        this.modalResult.disableHeaderButton = false;
      }
    );
  }
  
  get disableActions(): boolean {
    return this.showProgress;
  }

  get isItrButtonDisabled(): boolean {
    const w = this.modalResults.activeWorkflow;
    return w !== null && w !== 'itr';
  }

  get is26ASButtonDisabled(): boolean {
    const w = this.modalResults.activeWorkflow;
    return w !== null && w !== '26as';
  }

  get isFinancialButtonDisabled(): boolean {
    const w = this.modalResults.activeWorkflow;
    return w !== null && w !== 'financial';
  }

  get activeWorkflowLabel(): string {
    switch (this.modalResults.activeWorkflow) {
      case 'itr':       return 'Process ITR';
      case '26as':      return 'Process 26-AS';
      case 'financial': return 'Process Financial';
      default:          return '';
    }
  }

  toggleView = (viewType: string) => {
    if (viewType == 'V') {
      this.modalResult.viewType = 'Vertical';
      this.vClass = 'btn btn-light active';
      this.hClass = 'btn btn-light';

    }
    else {
      this.modalResult.viewType = 'Horizontal';
      this.vClass = 'btn btn-light';
      this.hClass = 'btn btn-light active';
    }
  }

  changePassword() {
    const ngbModelRef = this.ngbModal.open(ChangePasswordModalComponent, {
      windowClass: 'change-password-modal', backdrop: 'static', backdropClass: 'change-password-modal-backdrop'
    });

    ngbModelRef.result.then((result) => {
      if (!result) {
        // this.modalResult.selectedType = "";
        // this.modalResult.disableHeaderButton = false;
      }
    })
  };

}
